import React from "react";

import theme from "models/themes";

export const FolderClose = ({ onClick, style }) => (
  <svg
    style={style}
    onClick={onClick}
    width="18"
    height="14"
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 7L0.750001 7L0.750002 7L1.5 7ZM9 13.25L9 12.5L9 12.5L9 13.25ZM8.14439 1.18079L8.76104 0.753883L8.14439 1.18079ZM9.27869 2.81921L8.66204 3.24612L9.27869 2.81921ZM15.5 3.25L15.5 2.5L15.5 3.25ZM15.75 4.25L15.75 12.25L17.25 12.25L17.25 4.25L15.75 4.25ZM15.5 2.5L10.1009 2.5L10.1009 4L15.5 4L15.5 2.5ZM9.89533 2.3923L8.76104 0.753883L7.52775 1.6077L8.66204 3.24612L9.89533 2.3923ZM7.3222 -3.4157e-07L2.5 -7.55177e-08L2.5 1.5L7.3222 1.5L7.3222 -3.4157e-07ZM0.750002 1.75L0.750002 7L2.25 7L2.25 1.75L0.750002 1.75ZM0.750002 7L0.750002 12.25L2.25 12.25L2.25 7L0.750002 7ZM15.5 12.5L9 12.5L9 14L15.5 14L15.5 12.5ZM9 12.5L2.5 12.5L2.5 14L9 14L9 12.5ZM8.76104 0.753883C8.43417 0.281736 7.89646 -3.76073e-07 7.3222 -3.4157e-07L7.3222 1.5C7.40424 1.5 7.48105 1.54025 7.52775 1.6077L8.76104 0.753883ZM10.1009 2.5C10.0188 2.5 9.94203 2.45975 9.89533 2.3923L8.66204 3.24612C8.98891 3.71826 9.52662 4 10.1009 4L10.1009 2.5ZM17.25 4.25C17.25 3.2835 16.4665 2.5 15.5 2.5L15.5 4C15.6381 4 15.75 4.11193 15.75 4.25L17.25 4.25ZM2.5 -7.55177e-08C1.5335 1.44462e-09 0.750002 0.783502 0.750002 1.75L2.25 1.75C2.25 1.61193 2.36193 1.5 2.5 1.5L2.5 -7.55177e-08ZM0.750002 12.25C0.750002 13.2165 1.5335 14 2.5 14L2.5 12.5C2.36193 12.5 2.25 12.3881 2.25 12.25L0.750002 12.25ZM15.75 12.25C15.75 12.3881 15.6381 12.5 15.5 12.5L15.5 14C16.4665 14 17.25 13.2165 17.25 12.25L15.75 12.25Z"
      fill={theme.primary}
    />
  </svg>
);

export const FolderOpen = ({ onClick, style }) => (
  <svg
    style={style}
    onClick={onClick}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M10.3944 4.18079L11.011 3.75388L10.3944 4.18079ZM11.5287 5.81921L10.912 6.24612L11.5287 5.81921ZM17.75 6.25L17.75 5.5L17.75 6.25ZM18 7.25L18 15.25L19.5 15.25L19.5 7.25L18 7.25ZM17.75 5.5L12.3509 5.5L12.3509 7L17.75 7L17.75 5.5ZM12.1453 5.3923L11.011 3.75388L9.77775 4.6077L10.912 6.24612L12.1453 5.3923ZM9.5722 3L4.75 3L4.75 4.5L9.5722 4.5L9.5722 3ZM3 4.75L3 10L4.5 10L4.5 4.75L3 4.75ZM17.75 15.5L15 15.5L15 17L17.75 17L17.75 15.5ZM11.011 3.75388C10.6842 3.28174 10.1465 3 9.5722 3L9.5722 4.5C9.65424 4.5 9.73105 4.54025 9.77775 4.6077L11.011 3.75388ZM12.3509 5.5C12.2688 5.5 12.192 5.45975 12.1453 5.3923L10.912 6.24612C11.2389 6.71826 11.7766 7 12.3509 7L12.3509 5.5ZM19.5 7.25C19.5 6.2835 18.7165 5.5 17.75 5.5L17.75 7C17.8881 7 18 7.11193 18 7.25L19.5 7.25ZM4.75 3C3.7835 3 3 3.7835 3 4.75L4.5 4.75C4.5 4.61193 4.61193 4.5 4.75 4.5L4.75 3ZM18 15.25C18 15.3881 17.8881 15.5 17.75 15.5L17.75 17C18.7165 17 19.5 16.2165 19.5 15.25L18 15.25Z"
        fill={theme.primary}
      />
      <path
        d="M14.0502 10.3753L14.6359 9.90678L14.0502 10.3753ZM3.4587 15.7645L2.81558 16.1504L3.4587 15.7645ZM4.31619 16.25L4.31619 17L4.31619 16.25ZM0.265577 11.9004L2.81558 16.1504L4.10182 15.3786L1.55182 11.1286L0.265577 11.9004ZM16.6694 15.5L4.31619 15.5L4.31619 17L16.6694 17L16.6694 15.5ZM13.4646 10.8438L16.8646 15.0938L18.0359 14.1568L14.6359 9.90678L13.4646 10.8438ZM13.2694 9.25L1.76619 9.25L1.76619 10.75L13.2694 10.75L13.2694 9.25ZM14.6359 9.90678C14.3038 9.49166 13.801 9.25 13.2694 9.25L13.2694 10.75C13.3453 10.75 13.4171 10.7845 13.4646 10.8438L14.6359 9.90678ZM1.55182 11.1286C1.45184 10.962 1.57187 10.75 1.76619 10.75L1.76619 9.25C0.405926 9.25 -0.434273 10.7339 0.265577 11.9004L1.55182 11.1286ZM2.81558 16.1504C3.13185 16.6775 3.70148 17 4.31619 17L4.31619 15.5C4.22838 15.5 4.147 15.4539 4.10182 15.3786L2.81558 16.1504ZM16.6694 17C18.1368 17 18.9526 15.3026 18.0359 14.1568L16.8646 15.0938C16.9955 15.2575 16.879 15.5 16.6694 15.5L16.6694 17Z"
        fill={theme.primary}
      />
      ,style
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Eye = ({ onClick, style }) => (
  <svg
    style={style}
    onClick={onClick}
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M11.5421 11.1168C11.3362 11.3378 11.0878 11.5151 10.8118 11.6381C10.5358 11.7611 10.2378 11.8272 9.93572 11.8325C9.63361 11.8379 9.33352 11.7823 9.05336 11.6691C8.77319 11.556 8.51869 11.3875 8.30503 11.1739C8.09138 10.9602 7.92294 10.7057 7.80978 10.4255C7.69662 10.1454 7.64104 9.84529 7.64637 9.54318C7.6517 9.24108 7.71783 8.94314 7.84081 8.66714C7.96378 8.39114 8.14109 8.14274 8.36215 7.93675M14.4071 13.9818C13.1251 14.959 11.564 15.5004 9.95215 15.5268C4.70215 15.5268 1.70215 9.52675 1.70215 9.52675C2.63507 7.78817 3.929 6.26921 5.49715 5.07175L14.4071 13.9818ZM8.37715 3.70675C8.8934 3.58591 9.42195 3.52551 9.95215 3.52675C15.2021 3.52675 18.2021 9.52675 18.2021 9.52675C17.7469 10.3785 17.2039 11.1803 16.5821 11.9193L8.37715 3.70675Z"
        stroke={theme.primary}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.70215 1.27673L18.2021 17.7767"
        stroke={theme.primary}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="18" height="18" fill="white" transform="translate(0.952148 0.526733)" />
      </clipPath>
    </defs>
  </svg>
);

export const Arrow = ({ onClick, style, className }) => (
  <svg
    className={className}
    style={style}
    onClick={onClick}
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.5 3.75L5 6.25L7.5 3.75" stroke={theme.primary} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const More = ({ onClick, style, grey = false }) => (
  <svg
    style={style}
    onClick={onClick}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 9.75C9.41421 9.75 9.75 9.41421 9.75 9C9.75 8.58579 9.41421 8.25 9 8.25C8.58579 8.25 8.25 8.58579 8.25 9C8.25 9.41421 8.58579 9.75 9 9.75Z"
      stroke={grey ? theme.textSecondary : theme.primary}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.25 9.75C14.6642 9.75 15 9.41421 15 9C15 8.58579 14.6642 8.25 14.25 8.25C13.8358 8.25 13.5 8.58579 13.5 9C13.5 9.41421 13.8358 9.75 14.25 9.75Z"
      stroke={grey ? theme.textSecondary : theme.primary}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.75 9.75C4.16421 9.75 4.5 9.41421 4.5 9C4.5 8.58579 4.16421 8.25 3.75 8.25C3.33579 8.25 3 8.58579 3 9C3 9.41421 3.33579 9.75 3.75 9.75Z"
      stroke={grey ? theme.textSecondary : theme.primary}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Watermark = ({ style }) => (
  <svg style={style} width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 0L6.9287 7H5.71841L4.50812 2.84129L3.27347 7H2.06318L0 0H1.55144L2.73736 4.41433L4.02888 0H5.06859L6.31137 4.49298L7.55415 0H9Z"
      fill={theme.primary}
      stroke="#fff"
    />
  </svg>
);

export const File = ({ style }) => (
  <svg style={style} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.75004 6.53846L3.24132 5.98736C3.08751 6.12934 3.00004 6.32914 3.00004 6.53846L3.75004 6.53846ZM8.12502 2.5V1.75C7.93648 1.75 7.75485 1.82101 7.61631 1.9489L8.12502 2.5ZM16.25 3.75H15.5V3.75L16.25 3.75ZM16.25 16.25H17H16.25ZM3.75 16.25L4.5 16.25V16.25L3.75 16.25ZM3.75003 7.5L4.50003 7.5L3.75003 7.5ZM4.25875 7.08956L8.63373 3.0511L7.61631 1.9489L3.24132 5.98736L4.25875 7.08956ZM5.13889 18.25H14.8611V16.75H5.13889V18.25ZM15.5 3.75L15.5 16.25H17L17 3.75L15.5 3.75ZM5.13889 16.75C4.70975 16.75 4.5 16.4538 4.5 16.25L3 16.25C2.99999 17.4269 4.03389 18.25 5.13889 18.25V16.75ZM14.8611 18.25C15.9661 18.25 17 17.4269 17 16.25H15.5C15.5 16.4538 15.2902 16.75 14.8611 16.75V18.25ZM14.8611 3.25C15.2902 3.25 15.5 3.54623 15.5 3.75H17C17 2.57306 15.9661 1.75 14.8611 1.75V3.25ZM8.12502 3.25H9.30554V1.75H8.12502V3.25ZM9.30554 3.25H14.8611V1.75H9.30554V3.25ZM3.00004 6.53846L3.00003 7.5L4.50003 7.5L4.50004 6.53846L3.00004 6.53846ZM3.00003 7.5L3 16.25L4.5 16.25L4.50003 7.5L3.00003 7.5Z"
      fill={theme.primary}
    />
    <path d="M7.5 10H12.5" stroke={theme.primary} strokeWidth="1.5" strokeLinecap="round" />
    <path d="M7.5 13.75H10" stroke={theme.primary} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const Repeat = ({ onClick, style }) => (
  <svg
    style={style}
    onClick={onClick}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3335 0.666626L14.0002 3.33329L11.3335 5.99996"
      stroke={theme.primary}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 7.33337V6.00004C2 5.2928 2.28095 4.61452 2.78105 4.11442C3.28115 3.61433 3.95942 3.33337 4.66667 3.33337H14"
      stroke={theme.primary}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66667 15.3333L2 12.6667L4.66667 10"
      stroke={theme.primary}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 8.66663V9.99996C14 10.7072 13.719 11.3855 13.219 11.8856C12.7189 12.3857 12.0406 12.6666 11.3333 12.6666H2"
      stroke={theme.primary}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserIcon = ({ style }) => (
  <svg style={style} width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="42" height="42">
      <circle cx="21" cy="21" r="21" fill={theme.primary} />
    </mask>
    <g mask="url(#mask0)">
      <circle cx="21" cy="21" r="21" fill={theme.primary} />
      <path
        d="M17.0545 36.9057H14.4243C14.0845 36.9057 13.8091 37.1811 13.8091 37.5209C13.8091 37.8607 14.0845 38.1361 14.4243 38.1361H17.0545C17.3943 38.1361 17.6698 37.8607 17.6698 37.5209C17.6699 37.1812 17.3944 36.9057 17.0545 36.9057Z"
        fill="white"
      />
      <path
        d="M32.5045 29.3753L28.6598 27.8923L26.6953 25.9277C26.5649 25.7973 26.3896 25.7374 26.218 25.7492V24.0734C27.1465 23.0927 27.8059 21.8449 28.0645 20.4369C28.0679 20.4243 28.0885 20.4035 28.1027 20.3978C28.2744 20.4096 28.4481 20.3979 28.6195 20.3628C29.514 20.1798 30.1634 19.3482 30.1634 18.3857V17.8732C30.1634 17.2986 29.9231 16.7726 29.5347 16.4057C30.1672 13.0304 29.6665 10.2835 28.0809 8.4523C26.5569 6.69274 24.0967 5.85209 20.9665 6.02132C18.0282 6.18013 16.1514 7.54865 15.594 8.0136C14.8109 8.1113 12.4937 8.67329 12.4937 11.8962C12.4937 13.7197 12.7953 15.2294 12.9997 16.0438C12.3062 16.3481 11.8362 17.0605 11.8362 17.881V18.3857C11.8362 19.3482 12.4855 20.1798 13.3801 20.3629C13.5514 20.398 13.7253 20.4098 13.8968 20.3979C13.911 20.4036 13.9316 20.4243 13.9349 20.4363C14.1936 21.8446 14.8531 23.0926 15.7816 24.0733V25.7492C15.6098 25.7374 15.4346 25.7974 15.3043 25.9277L13.3398 27.8922L9.49508 29.3752C7.67293 30.0781 6.50112 31.8614 6.57938 33.8129L7.1239 47.4091C7.13719 47.7403 7.40977 47.9997 7.73823 47.9997C7.74659 47.9997 7.75496 47.9996 7.76333 47.9993C8.10285 47.9856 8.36699 47.6994 8.35346 47.3599L7.80894 33.7636C7.79294 33.3649 7.84856 32.9758 7.96594 32.6109L10.2033 34.8482C10.8323 35.4773 11.1788 36.3136 11.1788 37.2031V47.3846C11.1788 47.7244 11.4542 47.9998 11.794 47.9998C12.1338 47.9998 12.4092 47.7244 12.4092 47.3846V37.2029C12.4092 35.9848 11.9348 34.8395 11.0734 33.9781L8.58511 31.4898C8.93899 31.0679 9.39959 30.731 9.93804 30.5233L13.5556 29.1279L16.3104 33.2601C16.6324 33.7433 17.1485 34.0531 17.7264 34.1103C17.7907 34.1167 17.8548 34.1198 17.9187 34.1198C18.308 34.1198 18.6847 34.0023 19.0036 33.7845L18.4126 47.3577C18.3979 47.6971 18.661 47.9843 19.0006 47.9991C19.0097 47.9995 19.0188 47.9997 19.0278 47.9997C19.3553 47.9997 19.6276 47.7416 19.642 47.4112L20.188 34.8688H21.8121L22.3582 47.4112C22.3725 47.7415 22.6449 47.9997 22.9723 47.9997C22.9813 47.9997 22.9905 47.9995 22.9996 47.9991C23.339 47.9842 23.6022 47.6971 23.5875 47.3577L22.9965 33.7846C23.3154 34.0026 23.6921 34.12 24.0815 34.12C24.1453 34.12 24.2095 34.1168 24.2737 34.1105C24.8515 34.0533 25.3676 33.7434 25.6898 33.2603L28.4445 29.1281L32.0621 30.5234C32.6005 30.7311 33.0611 31.0681 33.415 31.49L30.9267 33.9782C30.0653 34.8396 29.5909 35.9849 29.5909 37.2031V47.3846C29.5909 47.7244 29.8664 47.9998 30.2061 47.9998C30.5459 47.9998 30.8214 47.7244 30.8214 47.3846V37.2031C30.8214 36.3136 31.1678 35.4773 31.7968 34.8482L34.0342 32.6109C34.1516 32.9758 34.2072 33.3649 34.1912 33.7636L33.6467 47.3599C33.6331 47.6994 33.8973 47.9856 34.2369 47.9993C34.2453 47.9996 34.2536 47.9997 34.262 47.9997C34.5903 47.9997 34.863 47.7403 34.8763 47.4091L35.4208 33.8129C35.4985 31.8615 34.3267 30.0782 32.5045 29.3753ZM15.1447 20.2139C15.029 19.5823 14.4449 19.124 13.8142 19.1701C13.7529 19.1746 13.6898 19.1703 13.6266 19.1574C13.3072 19.092 13.0664 18.7603 13.0664 18.3857V17.881C13.0664 17.5076 13.3107 17.1831 13.6348 17.1262C13.9019 17.0793 14.1585 17.1777 14.3209 17.3893C14.4387 17.543 14.5955 17.6527 14.7745 17.7069C15.0367 17.786 15.3258 17.7396 15.548 17.5827C16.0861 17.2029 16.5423 16.7211 16.9037 16.1506C17.0855 15.8636 17.0004 15.4836 16.7134 15.3016C16.4263 15.1198 16.0462 15.205 15.8644 15.4919C15.6444 15.8389 15.3795 16.1421 15.0745 16.3962C14.8382 16.1779 14.553 16.0249 14.2458 15.9461C14.0678 15.2828 13.7239 13.76 13.7239 11.8963C13.7239 9.32938 15.6351 9.22684 15.8485 9.22364C16.0075 9.22364 16.1602 9.16212 16.2748 9.05195C16.2919 9.03563 18.0128 7.41322 21.0326 7.24998C23.7691 7.10216 25.8847 7.79639 27.1503 9.25793C28.4389 10.7459 28.8592 13.0329 28.3762 15.8919C28.1547 15.8768 27.9017 15.8935 27.6523 15.9406L26.9648 14.2899C26.8469 14.0067 26.5376 13.8539 26.2411 13.9313C26.1754 13.9484 19.6307 15.6087 16.873 12.1756C16.6603 11.9107 16.2731 11.8684 16.0081 12.0812C15.7432 12.294 15.7009 12.6812 15.9137 12.9461C18.6999 16.4149 24.282 15.5994 26.028 15.2412L26.5664 16.5338C26.7693 17.0212 27.2882 17.2873 27.8003 17.1668C28.0266 17.1135 28.2593 17.1069 28.3635 17.1276C28.688 17.1921 28.9326 17.5126 28.9326 17.8731V18.3856C28.9326 18.7601 28.6918 19.0919 28.3723 19.1572C28.3092 19.1702 28.2462 19.1744 28.1848 19.17C27.5557 19.1237 26.9701 19.5822 26.8541 20.2139C26.3352 23.0392 23.8729 25.0899 20.9994 25.0899C18.1259 25.0899 15.6637 23.0392 15.1447 20.2139ZM18.4112 32.6843C18.2624 32.8332 18.057 32.9067 17.8473 32.8859C17.6378 32.8652 17.4507 32.7528 17.3339 32.5776L14.5581 28.4139L15.7672 27.2049L20.0996 30.9958L18.4112 32.6843ZM20.2413 33.6385L20.2888 32.5468L20.9997 31.8358L21.7106 32.5468L21.7581 33.6385H20.2413ZM20.9997 30.1484L17.012 26.6591V25.1109C18.1602 25.8778 19.5352 26.3206 20.9997 26.3206C22.4642 26.3206 23.8393 25.8778 24.9875 25.1109V26.6591L20.9997 30.1484ZM24.6655 32.5776C24.5487 32.7528 24.3616 32.8652 24.1521 32.8859C23.9423 32.9068 23.7371 32.8331 23.5882 32.6843L21.8998 30.9958L26.2322 27.2049L27.4413 28.4139L24.6655 32.5776Z"
        fill="white"
      />
    </g>
  </svg>
);

export const UserSmall = ({ onClick, style }) => (
  <svg
    style={style}
    onClick={onClick}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="10" r="10" fill={theme.primaryMiddle} />
    <path
      d="M14 14.5V13.5C14 12.9696 13.7893 12.4609 13.4142 12.0858C13.0391 11.7107 12.5304 11.5 12 11.5H8C7.46957 11.5 6.96086 11.7107 6.58579 12.0858C6.21071 12.4609 6 12.9696 6 13.5V14.5"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 9.5C11.1046 9.5 12 8.60457 12 7.5C12 6.39543 11.1046 5.5 10 5.5C8.89543 5.5 8 6.39543 8 7.5C8 8.60457 8.89543 9.5 10 9.5Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Clock = ({ color = theme.primary }) => (
  <svg enable-background="new 0 0 50 50" height="24px" id="Layer_1" version="1.1" viewBox="0 0 50 50" width="24px">
    <rect fill="none" height="50" width="50" />
    <circle
      cx="25"
      cy="25"
      fill="none"
      r="24"
      stroke={color}
      strokeLinecap="round"
      stroke-miterlimit="10"
      strokeWidth="2"
    />
    <circle cx="25" cy="25" r="3" fill={color} />
    <polyline
      fill="none"
      points="17,33 25,25 25,6   "
      stroke={color}
      strokeLinecap="round"
      stroke-miterlimit="10"
      strokeWidth="2"
    />
  </svg>
);

export const Upload = ({ primary = false, color = primary ? theme.primary : "#fff", onClick, style }) => (
  <svg
    onClick={onClick}
    style={style}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28 20V25.3333C28 26.0406 27.719 26.7189 27.219 27.219C26.7189 27.719 26.0406 28 25.3333 28H6.66667C5.95942 28 5.28115 27.719 4.78105 27.219C4.28095 26.7189 4 26.0406 4 25.3333V20"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.6663 10.6667L15.9997 4L9.33301 10.6667"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M16 4V20" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ClockBig = ({ color = "#fff" }) => (
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <defs></defs>
    <title />
    <g data-name="Layer 15" id="Layer_15">
      <path fill={color} d="M16,31A15,15,0,1,1,31,16,15,15,0,0,1,16,31ZM16,3A13,13,0,1,0,29,16,13,13,0,0,0,16,3Z" />
      <path fill={color} d="M20.24,21.66l-4.95-4.95A1,1,0,0,1,15,16V8h2v7.59l4.66,4.65Z" />
    </g>
  </svg>
);

export const ClockProgress = ({ color = theme.primary }) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="1">
      <path
        d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6 3V6L8 7" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </g>
  </svg>
);

export const HelpCircle = ({ color = theme.primary }) => (
  <svg width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M26.4142 47.9124C38.3804 47.9124 48.0809 38.2119 48.0809 26.2458C48.0809 14.2796 38.3804 4.5791 26.4142 4.5791C14.4481 4.5791 4.74756 14.2796 4.74756 26.2458C4.74756 38.2119 14.4481 47.9124 26.4142 47.9124Z"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.1094 19.7454C20.6188 18.2973 21.6242 17.0763 22.9476 16.2985C24.271 15.5207 25.827 15.2364 27.3399 15.4959C28.8529 15.7554 30.2251 16.542 31.2137 17.7164C32.2023 18.8907 32.7433 20.377 32.741 21.912C32.741 26.2454 26.241 28.412 26.241 28.412"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M26.4141 37.0791H26.4357" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Folder = ({ color = "#fff" }) => (
  <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.25 7.125C8.25 7.32391 8.17098 7.51468 8.03033 7.65533C7.88968 7.79598 7.69891 7.875 7.5 7.875H1.5C1.30109 7.875 1.11032 7.79598 0.96967 7.65533C0.829018 7.51468 0.75 7.32391 0.75 7.125V1.875C0.75 1.67609 0.829018 1.48532 0.96967 1.34467C1.11032 1.20402 1.30109 1.125 1.5 1.125H3.375L4.125 2.25H7.5C7.69891 2.25 7.88968 2.32902 8.03033 2.46967C8.17098 2.61032 8.25 2.80109 8.25 3V7.125Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Users = () => (
  <svg width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <path
        d="M36.8835 46.0566V41.7233C36.8835 39.4248 35.9704 37.2204 34.3451 35.5951C32.7197 33.9697 30.5153 33.0566 28.2168 33.0566H10.8835C8.58492 33.0566 6.38052 33.9697 4.7552 35.5951C3.12989 37.2204 2.2168 39.4248 2.2168 41.7233V46.0566"
        stroke="#6280DA"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5505 24.39C24.3369 24.39 28.2171 20.5098 28.2171 15.7233C28.2171 10.9368 24.3369 7.05664 19.5505 7.05664C14.764 7.05664 10.8838 10.9368 10.8838 15.7233C10.8838 20.5098 14.764 24.39 19.5505 24.39Z"
        stroke="#6280DA"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.8838 46.0562V41.7229C49.8824 39.8026 49.2432 37.9372 48.0667 36.4196C46.8903 34.9019 45.2431 33.818 43.3838 33.3379"
        stroke="#6280DA"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.7168 7.33789C36.581 7.81521 38.2334 8.89941 39.4133 10.4196C40.5933 11.9397 41.2338 13.8094 41.2338 15.7337C41.2338 17.6581 40.5933 19.5277 39.4133 21.0479C38.2334 22.568 36.581 23.6522 34.7168 24.1296"
        stroke="#6280DA"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="52" height="52" fill="white" transform="translate(0.050293 0.556641)" />
      </clipPath>
    </defs>
  </svg>
);

export const UserFill = ({ color = theme.primary }) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 15.75V14.25C15 13.4544 14.6839 12.6913 14.1213 12.1287C13.5587 11.5661 12.7956 11.25 12 11.25H6C5.20435 11.25 4.44129 11.5661 3.87868 12.1287C3.31607 12.6913 3 13.4544 3 14.25V15.75"
      fill={color}
    />
    <path
      d="M9 8.25C10.6569 8.25 12 6.90685 12 5.25C12 3.59315 10.6569 2.25 9 2.25C7.34315 2.25 6 3.59315 6 5.25C6 6.90685 7.34315 8.25 9 8.25Z"
      fill={color}
    />
  </svg>
);

export const EyePassword = ({ color = theme.primary, style, onClick = console.log }) => (
  <svg
    style={style}
    onClick={onClick}
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.583008 7.00004C0.583008 7.00004 2.91634 2.33337 6.99967 2.33337C11.083 2.33337 13.4163 7.00004 13.4163 7.00004C13.4163 7.00004 11.083 11.6667 6.99967 11.6667C2.91634 11.6667 0.583008 7.00004 0.583008 7.00004Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 8.75C7.9665 8.75 8.75 7.9665 8.75 7C8.75 6.0335 7.9665 5.25 7 5.25C6.0335 5.25 5.25 6.0335 5.25 7C5.25 7.9665 6.0335 8.75 7 8.75Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Globe = ({ color = theme.primary, style }) => (
  <svg style={style} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.00016 14.6666C11.6821 14.6666 14.6668 11.6819 14.6668 7.99998C14.6668 4.31808 11.6821 1.33331 8.00016 1.33331C4.31826 1.33331 1.3335 4.31808 1.3335 7.99998C1.3335 11.6819 4.31826 14.6666 8.00016 14.6666Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M1.3335 8H14.6668" stroke="#6280DA" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M8.00016 1.33331C9.66768 3.15888 10.6153 5.528 10.6668 7.99998C10.6153 10.472 9.66768 12.8411 8.00016 14.6666C6.33264 12.8411 5.38499 10.472 5.3335 7.99998C5.38499 5.528 6.33264 3.15888 8.00016 1.33331V1.33331Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Info = ({ color = theme.primary }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12 16V12" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 8H12.01" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const InfoSmall = ({ color = theme.primary, style = {}, opacity = 0.4, className }) => (
  <svg
    className={className}
    style={style}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity={opacity}>
      <path
        d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6 8V6" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 4H6.00667" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </g>
  </svg>
);

export const Refresh = ({ color = theme.primary, style = {}, onClick }) => (
  <svg
    onClick={onClick}
    style={style}
    width="9"
    height="9"
    viewBox="0 0 9 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path d="M8.625 1.5V3.75H6.375" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M0.375 7.5V5.25H2.625" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M1.31625 3.375C1.50644 2.83754 1.82967 2.35702 2.2558 1.97828C2.68193 1.59954 3.19705 1.33491 3.75311 1.20909C4.30917 1.08328 4.88803 1.10038 5.4357 1.25879C5.98336 1.4172 6.48197 1.71177 6.885 2.115L8.625 3.75M0.375 5.25L2.115 6.885C2.51803 7.28823 3.01664 7.5828 3.5643 7.74121C4.11197 7.89962 4.69083 7.91672 5.24689 7.7909C5.80295 7.66509 6.31807 7.40046 6.7442 7.02172C7.17032 6.64297 7.49356 6.16245 7.68375 5.625"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="9" height="9" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PlusCircle = ({ color = theme.primary }) => (
  <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.5 8.25C6.57107 8.25 8.25 6.57107 8.25 4.5C8.25 2.42893 6.57107 0.75 4.5 0.75C2.42893 0.75 0.75 2.42893 0.75 4.5C0.75 6.57107 2.42893 8.25 4.5 8.25Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M4.5 3V6" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3 4.5H6" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
